import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white pt-32 pb-10 relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full text-center pointer-events-none select-none overflow-hidden">
        <h2 className="text-[20vw] font-serif font-bold text-white/5 leading-none m-0 p-0 translate-y-1/4">GLOW</h2>
      </div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-24">
          
          <div className="md:col-span-5">
            <Link to="/" className="text-3xl font-serif font-bold tracking-widest uppercase mb-8 block text-white">
              Glow<span className="text-brand-accent">Consulting</span>
            </Link>
            <p className="text-white/60 text-lg leading-relaxed mb-8 max-w-md font-light">
              Premium Business Mentoring für Frauen in der Beauty- und Influencer-Branche. Werde sichtbar, selbstbewusst und wirtschaftlich erfolgreich.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-accent hover:border-brand-accent hover:text-white transition-all duration-300">
                <SafeIcon name="Instagram" className="w-5 h-5" />
              </a>
              <a href="mailto:hallo@glowconsulting.de" className="w-12 h-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-accent hover:border-brand-accent hover:text-white transition-all duration-300">
                <SafeIcon name="Mail" className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] mb-8 text-brand-accent">Navigation</h4>
            <ul className="space-y-4 text-base font-light text-white/70">
              <li><Link to="/" className="hover:text-brand-accent transition-colors">Startseite</Link></li>
              <li><Link to="/ueber-mich" className="hover:text-brand-accent transition-colors">Die Visionärin</Link></li>
              <li><Link to="/leistungen" className="hover:text-brand-accent transition-colors">Expertise</Link></li>
              <li><Link to="/pakete" className="hover:text-brand-accent transition-colors">Investment</Link></li>
              <li><Link to="/kontakt" className="hover:text-brand-accent transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] mb-8 text-brand-accent">Kontakt</h4>
            <ul className="space-y-6 text-base font-light text-white/70">
              <li className="flex items-start gap-4 hover:text-brand-accent transition-colors">
                <SafeIcon name="Mail" className="w-6 h-6 text-brand-accent shrink-0" />
                <a href="mailto:hallo@glowconsulting.de">hallo@glowconsulting.de</a>
              </li>
              <li className="flex items-start gap-4">
                <SafeIcon name="MapPin" className="w-6 h-6 text-brand-accent shrink-0" />
                <span>Online & Vor Ort<br />Axel-Springer-Platz 3<br/>20355 Hamburg</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-white/40 font-light">
          <p>&copy; {new Date().getFullYear()} glowconsulting.de by Rukiye Amini. Alle Rechte vorbehalten.</p>
          <div className="flex gap-8">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;